import { defineStore } from 'pinia'
import { User } from '../interfaces/user'

export const useCurrentUserStore = defineStore('currentUser', {
  state: () => ({
    user: {} as Partial<User>
  }),

  getters: {
    getUser (): Partial<User> {
      return this.user
    }
  },

  actions: {
    setUser (payload: Partial<User>) {
      this.user = payload
    },

    loadFromJson (payload: Partial<User>) {
      this.setUser(payload)
    }
  }
})
